import Header from '../Header/Header';
import { CustomTable, ConfirmationPopup, SuccessModal, Pagination, Search, ReschedulePopup, Loader, ICONS, Icon } from '@ohif/ui';
import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _appointmentUrls, _commonUrls, _hospitalUrls } from '@custom/Utils/constants/apiUrls';
import { DatePickerWithRange } from '@ohif/ui-next';
import { _routes } from '@custom/Utils/constants/routes';

import { columns } from './constant';
import { fetchPatientCount, postMWLItems, postPatientData } from '@custom/Appointments/mwlHelperMethods';
import { servicesManager } from '../../app/src/App';
import { calculateAge, capitalizeWords, customStyle, formatDate, formatTime, getCurrencyContact } from '@custom/Utils/utils';
import FilterForm from './FilterForm';
import { useTheme } from "../../ui/src/contextProviders"
import { getTemplatesInMoreActions } from './helper';
import StudyUploadModal from '@custom/StudyList/components/importStudyModal';
import { useDispatch, useSelector } from 'react-redux';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import { AppDispatch, RootState } from '@custom/store/store';
import editInvoiceByIdApi from '@custom/rtk-apis/billing/invoice/editInvoiceById';
import fetchActiveMachineList from '@custom/rtk-apis/activeMachine/activeMachineList';
import getAppointmentStudy from '@custom/rtk-apis/appointment/getStudy';

interface RelatedInvoices {
  CANCELED_INVOICE?: Array<{ _id: string; canceledBillItems?: any[] }>;
  canceled_invoice?: Array<{ _id: string; canceledBillItems?: any[] }>;
  INVOICE?: Array<{ _id: string; canceledBillItems?: any[] }>;
  invoice?: Array<{ _id: string; canceledBillItems?: any[] }>;
}

interface ApiResponse {
  status: boolean;
  result?: {
    relatedInvoices?: RelatedInvoices;
  };
  msg?: string;
}

const Appointments = () => {
  const userRole = sessionStorage?.getItem("role");
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const [modalityList, setModality] = useState([]);
  const [reportStatus, setReportStatus] = useState([]);
  const [moreActions, setMoreActions] = useState([]);
  const [filterData, setFilterData] = useState({
    status: [],
    modality: []
  });
  const { isDarkMode } = useTheme();
  const [studyUploadModal, setStudyUploadModal] = useState(false);
  const handleStudyUploadModal = () => {
    setStudyUploadModal(true);
  }
  const handleStudyUploadModalClose = () => {
    setStudyUploadModal(false);
  }

  const { uiNotificationService } = servicesManager.services;

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [successModalText, setSuccessModalText] = useState('');
  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const [confirmationPopup, setConfirmationPopup] = useState({
    tite: '',
    message: '',
    status: '',
  })
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const buttonRef = useRef(null);
  const filterPopupRef = useRef(null);

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  // Close filter popup when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFilterOpen &&
        filterPopupRef.current &&
        !filterPopupRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFilterOpen]);
  // updatedDateTime state
  const [updatedDateTime, setUpdatedDateTime] = useState({
    date: '',
    time: '',
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [load, setLoad] = useState(true);

  const [searchQuery, setSearchQuery] = useState('');
  const [tableData, setTableData] = useState([])
  const [search, setSearch] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [totalPg, setTotalPg] = useState(1000000);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedCount, setSelectedCount] = useState(0);
  const formikRef = useRef(null);
  const [dateRange, setDateRange] = useState<{
    startDate: string | null;
    endDate: string | null
  }>({
    startDate: null,
    endDate: null
  });

  const navigation = useNavigate()

  const onPageChangeHandler = pg => {
    setPgNumber(pg);
  };
  const handlePageSizeChange = e => {
    setPgLimit(e);
  };

  const resetFilter = () => {
    setStartDate("");
    setEndDate("");
    setDateRange({
      startDate: null,
      endDate: null
    });
    setSearch("");
    setSearchInputValue("");
    getAllAppointmentList("", pgLimit, 1, "", "");
    setPgNumber(1);
    setFilterData({
      status: [],
      modality: []
    });
    setSelectedCount(0);
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
      formikRef.current.setFieldValue('modality', []);
    }
  };

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        setModality(commonData?.result?.modality);
        setReportStatus(commonData?.result?.reportStatus);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchCommonData();
    dispatch(getBillingGeneralSettings());
  }, []);

  const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

  const handleDateChange = (dates: { startDate: string, endDate: string }) => {
    const { startDate, endDate } = dates;

    if (startDate && endDate) {
      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);

      setDateRange({ startDate, endDate });
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);

      setFilterData(prevValues => ({
        ...prevValues,
        Date: {
          startDate: formattedStartDate,
          endDate: formattedEndDate
        }
      }));

      if (formattedStartDate && formattedEndDate) {
        getAllAppointmentList(search, pgLimit, pgNumber, startDate, endDate);
      }
    }
  };

  const filterFormInitialValue = {
    status: filterData?.status || [],
    modality: filterData?.modality || []
  }

  const handleSaveForm = (values) => {
    setFilterData(values);
    setPgNumber(1);
    setIsFilterOpen(false);
    const selectedStatusCount = values.status ? values.status.length : 0;
    const selectedModalityCount = values.modality ? values.modality.length : 0;
    const totalSelectedCount = selectedStatusCount + selectedModalityCount;
    setSelectedCount(totalSelectedCount);
  }

  const handleResetForm = () => {
    setFilterData({
      status: [],
      modality: []
    });
    setIsFilterOpen(false);
    setSelectedCount(0);
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
    }
  }

  const checkIfStudyIsPresent = async (item) => {
    const payload = item?.patientId;

    try {
      const response = await dispatch(getAppointmentStudy(payload)).unwrap();

      if (response?.[0]?.["0020000D"]?.Value?.[0]) {
        const studyInstanceUID = response[0]["0020000D"].Value[0];
        return true;
      } else {
        console.error('StudyInstanceUID not found in response:', response);

        return false;
      }
    } catch (error) {
      if (error.name === 'SyntaxError' && error.message.includes('Unexpected end of JSON input')) {
        console.error('Empty or invalid JSON response:', error);

        return false;
      } else {
        console.error('Error during API call:', error);

        return false;
      }
    }
  };


  let actions = [
    {
      label: 'Send to MWL',
      iconName: 'confirm',
      onClick: (item) => {
        if (!localStorage.getItem('local_pacs_access_token') && !sessionStorage.getItem('local_pacs_access_token')) {
          uiNotificationService.show({
            title: 'Send to MWL',
            message: 'No PACS is ACTIVE. Please ACTIVATE a PACS and try again.',
            type: 'error',
          });
          return;
        }

        setSelectedRow(item);
        setConfirmationPopup({
          tite: 'Send to MWL',
          message: 'Are you sure you want to send this appointment details to MWL?',
          status: 'Confirmed',
        });
        setIsPopupOpen(true);
      },
    },
    {
      label: 'Preview',
      iconName: 'preview',
      onClick: ((item) => {
        handlePreview(item?._id)
      })
    },
    {
      label: 'Reschedule',
      iconName: 'reschedule',
      onClick: ((item) => {
        navigate("/addappointment", {
          state: {
            userData: {
              ...item?.appointmentDetails,
              appointmentType: item?.appointmentDetails?.appointmentType
            },
            mode: "edit"
          }
        })
      })
    },
    {
      label: 'Cancel',
      iconName: 'delete',
      onClick: ((item) => {
        setSelectedRow(item);
        setSuccessModalText('Appointment cancelled successfully.')
        setConfirmationPopup({
          tite: 'Cancel Appointment !',
          message: 'Are you sure you want to cancel this appointment?',
          status: 'Cancelled',
        })
        setIsPopupOpen(true)
      })
    },
    {
      label: 'Import Study',
      iconName: 'importStudy',
      onClick: async (item) => {
        setLoad(true);
        const studyExists = await checkIfStudyIsPresent(item);
        setLoad(false);
        if (studyExists) {
          uiNotificationService.show({
            title: 'Import Study',
            message: 'Scan is already present.',
            type: 'warning',
          });
          return;
        }

        setSelectedRow(item);
        handleStudyUploadModal();
      }
    },
    {
      label: 'Patient Details',
      iconName: 'patientDetails',
      onClick: async (item) => {
       navigate(`/patient/detail/${item.uhid}`, {
        state: {
          userRole: item?.appointmentDetails?.patientInfo?.createdByDetails?.role || 'unknown',
        },
      });
      }
    },
  ];

  const getActionAccordingToRole = (actions) => {
    const role = sessionStorage.getItem("role") || localStorage.getItem("role");
    if (userRole === 'Radiologist' || userRole === 'Clinician' || userRole === 'Resident' || userRole === 'Government') {
      const action = actions.filter(action => action.label === 'Preview');
      return action
    }else if (role === 'technicianradiology') {
      const action = actions.filter(action => action.label !== 'Reschedule' && action.label !== 'Cancel' && action.label !== 'Import Study');
      return action
    }
    else {
      return actions
    }
  }
  const handlePreview = (id) => navigation(_routes.appointments.previewWithId(id))

  const handleConfirmReschedule = async () => {
    try {
      // Perform reschedule action here
      setIsReschedulePopupOpen(false);
      const response = await apiRequest(
        {
          method: 'PUT',
          endUrl: _appointmentUrls.reschedule,
          headerType: 'json',
          params: { _id: selectedRow?._id },
          body: { date: updatedDateTime?.date, time: updatedDateTime?.time }
        }
      )
      if (response.status) {
        setIsSuccessModal(true)
        setConfirmationPopup({
          tite: 'Reschedule Appointment !',
          message: 'Are you sure you want to reschedule this appointment?',
          status: 'Rescheduled',
        })
        setIsPopupOpen(false);
        const response = await apiRequest(
          {
            method: 'PATCH',
            endUrl: _appointmentUrls.updateStaus,
            headerType: 'json',
            params: { _id: selectedRow?._id },
            body: { status: "Rescheduled" }
          }
        )
        if (response.status) {
          setIsSuccessModal(true)
        }
        getAllAppointmentList(search, pgLimit, pgNumber)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const handleChangeStatus = async () => {
    try {
      // Perform delete action here
      setIsPopupOpen(false);
      setLoad(true)
      if (confirmationPopup.status === 'Confirmed') {

        sendToMWLHandler(selectedRow)
      }
      else {
        changeAppointmentStatus(selectedRow)
      }

    }
    catch (error) {
    }
  };
  const changeAppointmentStatus = async (selectedRow: any) => {
    try {
      const response: ApiResponse = await apiRequest({
        method: 'PATCH',
        endUrl: _appointmentUrls.updateStaus,
        headerType: 'json',
        params: { _id: selectedRow?._id },
        body: { status: confirmationPopup.status },
      });

      const relatedInvoices: RelatedInvoices = response?.result?.relatedInvoices || {};
      const canceledInvoice = relatedInvoices.CANCELED_INVOICE?.[0] || relatedInvoices.canceled_invoice?.[0];
      const invoice = relatedInvoices.INVOICE?.[0] || relatedInvoices.invoice?.[0];
      const invoiceResult = canceledInvoice || invoice;

      if (response.status === true) {
        setLoad(false);
        setIsSuccessModal(true);
        setTimeout(() => {
          getAllAppointmentList(search, pgLimit, pgNumber);
          setIsSuccessModal(false);
        }, 500);

        if (invoiceResult) {
          if (invoiceResult.invoiceStatus === 'Unpaid') {
            uiNotificationService.show({
              title: 'Invoice Update Skipped',
              message: 'Invoice update skipped because the invoice status is Unpaid.',
              type: 'info',
            });
          } else {
            const payload = {
              canceledBillItems: invoiceResult.canceledBillItems || [],
              cancelItems: [],
              statusOfBill: confirmationPopup.status,
              reasonOfCancel: 'Cancelled due to appointment cancellation',
            };

            try {
              const invoiceResponse = await dispatch(
                editInvoiceByIdApi({
                  body: payload,
                  id: invoiceResult._id,
                })
              ).unwrap();
            } catch (invoiceError) {
              uiNotificationService.show({
                title: 'Invoice Update Failed',
                message: 'Failed to update invoice status. Please try again.',
                type: 'error',
              });
            }
          }
        } else {
          uiNotificationService.show({
            title: 'Invoice Data Missing',
            message: 'No invoice data available to update.',
            type: 'info',
          });
        }
      } else {
        setLoad(false);
        uiNotificationService.show({
          title: 'Status Update Failed',
          message: response?.msg || 'Failed to update appointment status.',
          type: 'error',
        });
      }
    } catch (error) {
      setLoad(false);
      uiNotificationService.show({
        title: 'Error',
        message: 'An unexpected error occurred while updating the appointment.',
        type: 'error',
      });
    }
  };
  async function sendToMWLHandler(item) {
    const countRes = await fetchPatientCount(item?.uhid);
    const machinelist = await dispatch(fetchActiveMachineList({ limit: 50, pageNumber: 1, search: '' })).unwrap()

    if (countRes === null) {
      setLoad(false)
      uiNotificationService.show({
        title: 'Send to MWL',
        message:
          'Error occured while adding patient to MWL',
        type: 'error',
      });

      return;
    }

    let aeTitle = '';
    if (item.modality) {
      const machineGroup = machinelist?.result?.list?.find((group) => group.machineType === item.modality);
      if (machineGroup) {
        const machine = machineGroup.machines.find((m) => m.machineName === item?.appointmentDetails?.machineName);
        aeTitle = machine ? machine.aeTitle : '';
      }
    }


    const mwlDetails = {
      patId: item?.uhid,
      patAge: `${String(item?.age).padStart(3, "0")}Y`,
      modality: item?.modality,
      stepProcedureDisc: item?.studyRegion,
      accessionNumber: item?.patientId,
      aeTitle: aeTitle,
    };

    if (countRes?.count > 0) {
      const mwlRes = await postMWLItems(mwlDetails);

      if (!mwlRes) {
        setLoad(false)
        uiNotificationService.show({
          title: 'Send to MWL',
          message:
            'Error occured while adding patient to MWL',
          type: 'error',
        });

        return;
      }
    }
    else {

      const patientDetails = {
        patName: item?.name,
        patId: item?.uhid,
        patIdIssuer: 'QSS',
        patDob: item?.dob?.replace(/-/g, ''),
        patSex: item?.gender === 'Male' ? 'M' : item.gender === 'Female' ? 'F' : 'O'
      };

      const isPatAdded = await postPatientData(patientDetails);

      if (isPatAdded) {
        const mwlRes = await postMWLItems(mwlDetails);

        if (!mwlRes) {
          setLoad(false)

          uiNotificationService.show({
            title: 'Send to MWL',
            message:
              'Error occured while adding patient to MWL',
            type: 'error',
          });

          return;
        }
      }
      else {
        setLoad(false)

        uiNotificationService.show({
          title: 'Send to MWL',
          message:
            'Error occured while adding patient to MWL',
          type: 'error',
        });

        return;
      }
    }
    if (item?.appointmentDetails?.extraModalities?.length > 0) {

      item.appointmentDetails.extraModalities.forEach(async (element) => {

        if (element?.modality) {
          const machineGroup = machinelist?.result?.list?.find((group) => group.machineType === element?.modality);
          if (machineGroup) {
            const machine = machineGroup.machines.find((m) => m.machineName === element?.machineName);
            aeTitle = machine ? machine.aeTitle : '';
          }
        }
        const extraMwlDetails = {
          patId: item?.uhid,
          patAge: `${String(item?.age).padStart(3, "0")}Y`,
          modality: element.modality,
          stepProcedureDisc: element.studyRegion,
          accessionNumber: item?.patientId,
          aeTitle: aeTitle,
        };

        const extraMwlRes = await postMWLItems(extraMwlDetails);

        if (!extraMwlRes) {
          uiNotificationService.show({
            title: 'Send to MWL',
            message: 'Error occurred while adding patient to MWL',
            type: 'error',
          });
          setLoad(false);
        }
      })
    }
    setLoad(false)
    setIsSuccessModal(true)
    setSuccessModalText("Appointment has been successfully added to MWL.")
    changeAppointmentStatus(item)
    setTimeout(() => {
      setIsSuccessModal(false)
      setSuccessModalText("")
    }, 500)
  }

  const handleCancel = () => {
    setIsPopupOpen(false);
  };

  const navigateToPage = () => {
    if (billingGeneralSettingsData?.msg === "General settings not found for this hospital.") {
      uiNotificationService.show({
        title: 'Billing Settings',
        message: 'Fill the general settings to create appointment.',
        type: 'error',
      });
      navigate('/billing');
    } else {
      navigate("/addappointment");
    }
  }

  useEffect(() => {
    getAllAppointmentList(search, pgLimit, pgNumber, dateRange?.startDate, dateRange?.endDate);
  }, [search, pgLimit, pgNumber, startDate, endDate, filterData?.status, filterData?.modality])

  const getFormatDate = (dateString) => {
    if (dateString?.length !== 8) {
      return '';
    }
    const day = dateString?.slice(0, 2);
    const month = dateString?.slice(2, 4);
    const year = dateString?.slice(4, 8);
    return `${year}-${month}-${day}`;
  };

  const getAllAppointmentList = async (searchText, limit, number, fromDate, toDate) => {
    setLoad(true);

    try {
      const hasValidDateRange = (fromDate && toDate) || (!fromDate && !toDate);

      if (!hasValidDateRange) {
        setLoad(false);
        return;
      }

      const queryParams = {
        searchQ: searchText || '',
        limit: Number(limit) || 30,
        offset: Number(limit || 30) * (Number(number || 1) - 1),
        hospitalId: sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId'),
        status: filterData?.status || [],
        from: (localStorage.getItem('role') || sessionStorage.getItem('role') || '').toLowerCase() === 'government'
          ? 'government'
          : localStorage.getItem('role') || sessionStorage.getItem('role') || '',
        modality: filterData?.modality || [],
        fromDate: fromDate ? getFormatDate(fromDate) : '',
        toDate: toDate ? getFormatDate(toDate) : '',
      };

      const response = await apiRequest({
        method: 'POST',
        endUrl: _appointmentUrls.list,
        headerType: 'json',
        body: queryParams,
      });

      if (response?.status) {
        setLoad(false);
        const tempArray = response?.result?.list?.map((item) => ({
          _id: item?._id || '--',
          name: item?.patientInfo
            ? `${capitalizeWords(item.patientInfo.firstName)} ${capitalizeWords(item.patientInfo.lastName)}`.trim() || '--'
            : '--',
          phoneNumber: `${item?.patientInfo?.contactInfo?.dialCode || ''} ${item?.patientInfo?.contactInfo?.mobileNo}` || '--',
          dob: formatDate(item?.patientInfo?.dob) || '--',
          patientId: item?.patientInfo?.patientId || '--',
          gender: item?.patientInfo?.gender || '--',
          age: calculateAge(item?.patientInfo?.dob) || item?.patientInfo?.age || '0',
          uhid: item?.patientInfo?.UHID || '--',
          date: formatDate(item?.date) || '--',
          time: formatTime(item?.time) || '--',
          modality: item?.modality || '--',
          consultingDoctor: item?.doctorName || '--',
          status: item?.status || '--',
          appointmentDetails: item || '--',
          action: actions || '--',
          studyRegion: item?.studyRegion || '--',
          priority: item?.priority === 'Urgent' ? 'Priority' : item?.priority || '--',
          mppsStatus: item.mppsStatus || '--',
          hasReport: item.hasReport,
          title: item.hasReport ? 'View Report' : 'Generate Report',
        }));

        setTableData(tempArray);
        setTotalPg(response?.result?.count);
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    }
  };

  const searchClick = searchText => {
    setSearch(searchText);
    setSearchInputValue(searchText);
    setPgNumber(1);
  }

  const getMoreActions = async () => {
    const mActions = await getTemplatesInMoreActions(navigate);
    setMoreActions(mActions);
  }

  useEffect(() => {
    getMoreActions();
  }, [])

  return (
    <>
      <div className='page page__fullBody' style={
        isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header title={userRole === 'Radiologist' ? 'Study List' : 'Appointments'} isBack={false} />
        <div className='page__body'>
          <div className='tableWrap'>
            <div className='tableWrap__head'>
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className='formCol'>
                  <Search
                    text="Patient Name, Contact Number, Patient ID, UHID"
                    onSearchClick={searchClick}
                    value={searchInputValue}
                    setValue={setSearchInputValue}
                  />
                </div>
                <div className='formCol'>
                  <DatePickerWithRange
                    className="px-4 py-1 rounded h-10"
                    onChange={handleDateChange}
                    startPlaceholder="From"
                    endPlaceholder="To"
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                    style={{ width: '200px' }}
                  />
                </div>
                <div className="formCol">
                  <div className='btn__group relative'>
                    <button ref={buttonRef} onClick={toggleFilter} className="filter-button">
                      <img src={ICONS.filterIcon} alt="down arrow" />Filter
                    </button>
                    {selectedCount > 0 && (
                      <span className="badge absolute top-0 left-0 translate-x-1/2 translate-y-1/2">
                        {selectedCount}
                      </span>
                    )}
                    {isFilterOpen && (
                      <div
                        ref={filterPopupRef}
                        className="filter-popup"
                        style={{
                          position: 'absolute',
                          top: buttonRef.current.offsetHeight + 10,
                          left: 0,
                          zIndex: 100,
                          backgroundColor: "#ffffff",
                          border: '1px solid #ccc',
                          padding: '10px',
                          width: "500px",
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        }}
                      >
                        <FilterForm
                          filterFormInitialValue={filterFormInitialValue}
                          handleSaveForm={handleSaveForm}
                          handleResetForm={handleResetForm}
                          reportStatus={reportStatus}
                          modalityList={modalityList}
                        />
                      </div>
                    )}
                    <button onClick={resetFilter} className="filter-button" style={{ marginLeft: '5px' }}>
                      <Icon name="ClearFilters" className="text-black cursor-pointer" width="16" height="16"></Icon>
                      Clear
                    </button>
                  </div>

                </div>
              </div>
              <div className='formCol'>
                {userRole !== 'Radiologist' && userRole !== 'Clinician' && userRole !== 'Resident' && userRole !== 'Government' && userRole !== 'technicianradiology' && <div className='btn__group'>
                  <button className="btn btn__white" onClick={navigateToPage}>
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.63509 1.16699V12.8337M1.80176 7.00033H13.4684" stroke="#150823" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Add Appointment</button>
                </div>
                }
              </div>
            </div>
            <div className='tableContainer'>
              <CustomTable columns={columns} data={tableData} actions={getActionAccordingToRole(actions)} moreActions={moreActions} searchQuery={searchQuery} from="appointment" userDetails={''} setClickedItem={''} clickedItem={''} />
            </div>
          </div>
        </div>
        {tableData.length > 0 && <Pagination
          onChangePage={onPageChangeHandler}
          onChangePerPage={handlePageSizeChange}
          totalPage={totalPg}
          currentPage={pgNumber}
          perPage={pgLimit}
        />}
      </div>
      <StudyUploadModal isOpen={studyUploadModal} onClose={handleStudyUploadModalClose} patientData={selectedRow} />
      <ReschedulePopup
        isOpen={isReschedulePopupOpen}
        date={selectedRow?.date}
        time={selectedRow?.time}
        setUpdatedDateTime={setUpdatedDateTime}
        onCancel={() => setIsReschedulePopupOpen(false)}
        onConfirm={handleConfirmReschedule}
      />
      <ConfirmationPopup
        isOpen={isPopupOpen}
        title={confirmationPopup.tite}
        message={confirmationPopup.message}
        onConfirm={handleChangeStatus}
        onCancel={handleCancel}
      />
      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={successModalText}
        handleCloseModal={() => setIsSuccessModal(false)}
      />
      <Loader isLoaderOpen={load}></Loader>
    </>
  )
}

export default Appointments
